import FluentUiIcon from "../../../../../assets/fluent-ui-icon";

export const tabList = [
  {
    Label: "General Properties",
    Icon: (
      <FluentUiIcon name={"WindowTextBundle"} color={"#212121"} size={18} />
    ),
    Id: "General",
  },
  {
    Label: "Reminders",
    Icon: <FluentUiIcon name={"AlertBundle"} color={"#212121"} size={18} />,
    Id: "Reminders",
  },
  {
    Label: "Task Layout",
    Icon: (
      <FluentUiIcon
        name={"TextBulletListSquareEditBundle"}
        color={"#212121"}
        size={18}
      />
    ),
    Id: "Task Layout",
  },
  {
    Label: "Form Design",
    Icon: (
      <FluentUiIcon name={"FormMultipleBundle"} color={"#212121"} size={18} />
    ),
    Id: "Form",
  },
      {
    Label: "Form Statuses",
    Icon: <FluentUiIcon name={"TaskListRtlRegular"} color={"#212121"} size={18} />,
    Id: "Form Statuses",
  },
  {
    Label: "In-Form Automations",
    Icon: (
      <FluentUiIcon name={"SlideSettingsBundle"} color={"#212121"} size={18} />
    ),
    Id: "In-Form Automations",
  },
  {
    Label: "In-Form-Automations (E)",
    Icon: (
      <FluentUiIcon name={"SlideSettingsBundle"} color={"#212121"} size={18} />
    ),
    Id: "In-Form Automations Enhanced",
  },
  {
    Label: "Workflow",
    Icon: <FluentUiIcon name={"FlowchartBundle"} color={"#212121"} size={18} />,
    Id: "Workflow",
  },

  {
    Label: "Rules",
    Icon: <FluentUiIcon name={"SparkleBundle"} color={"#212121"} size={18} />,
    Id: "Rules",
  },
];

export const PrepareBreadCrumbList = (taskType, selectedTab, setSelectedValue) => {
  return [
    { Href: "/admin", Text: "Admin" },
    { Href: "/admin?tab=task-types", Text: "Task Types" },
    {
      Href: null,
      Text: taskType === "" ? "Untitled Task Type" : taskType,
      clickevent: () => {
        setSelectedValue("General");
      },
    },
    { Href: null, Text: selectedTab },
  ];
};
